/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type OffersContainer_lists$ref = any;
export type OffersContainerQueryVariables = {|
  first?: ?number,
  after?: ?string,
  startingAfter?: ?any,
  endingBefore?: ?any,
  active?: ?boolean,
|};
export type OffersContainerQueryResponse = {|
  +lists: ?{|
    +$fragmentRefs: OffersContainer_lists$ref
  |}
|};
export type OffersContainerQuery = {|
  variables: OffersContainerQueryVariables,
  response: OffersContainerQueryResponse,
|};
*/


/*
query OffersContainerQuery(
  $first: Int = 100
  $after: String
  $startingAfter: DateTime
  $endingBefore: DateTime
  $active: Boolean = true
) {
  lists {
    ...OffersContainer_lists_4FAQLc
    id
  }
}

fragment OfferCell_offer on Offer {
  id
  title
  description
  store {
    name
    id
  }
  imageUrl
  startDate
  endDate
  isFlash
  isLatest
  isPromoted
  isRedeemable
  isCheckIn
  redemptionCode
  finePrint
  isTop
  shareableUrl
  appUrl
}

fragment OfferList_offers on Offer {
  id
  ...OfferCell_offer
}

fragment OffersContainer_lists_4FAQLc on Lists {
  offers(first: $first, after: $after, startingAfter: $startingAfter, endingBefore: $endingBefore, active: $active) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        ...OfferList_offers
        __typename
      }
      cursor
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": 100,
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "startingAfter",
    "type": "DateTime"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "endingBefore",
    "type": "DateTime"
  },
  {
    "defaultValue": true,
    "kind": "LocalArgument",
    "name": "active",
    "type": "Boolean"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "active",
    "variableName": "active"
  },
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "endingBefore",
    "variableName": "endingBefore"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "startingAfter",
    "variableName": "startingAfter"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OffersContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Lists",
        "kind": "LinkedField",
        "name": "lists",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "FragmentSpread",
            "name": "OffersContainer_lists"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OffersContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Lists",
        "kind": "LinkedField",
        "name": "lists",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "OfferConnection",
            "kind": "LinkedField",
            "name": "offers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "OfferEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Offer",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "description",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Store",
                        "kind": "LinkedField",
                        "name": "store",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "imageUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isFlash",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isLatest",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isPromoted",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isRedeemable",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isCheckIn",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "redemptionCode",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "finePrint",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isTop",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "shareableUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "appUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v1/*: any*/),
            "filters": [
              "active",
              "startingAfter",
              "endingBefore"
            ],
            "handle": "connection",
            "key": "Offers_offers",
            "kind": "LinkedHandle",
            "name": "offers"
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "OffersContainerQuery",
    "operationKind": "query",
    "text": "query OffersContainerQuery(\n  $first: Int = 100\n  $after: String\n  $startingAfter: DateTime\n  $endingBefore: DateTime\n  $active: Boolean = true\n) {\n  lists {\n    ...OffersContainer_lists_4FAQLc\n    id\n  }\n}\n\nfragment OfferCell_offer on Offer {\n  id\n  title\n  description\n  store {\n    name\n    id\n  }\n  imageUrl\n  startDate\n  endDate\n  isFlash\n  isLatest\n  isPromoted\n  isRedeemable\n  isCheckIn\n  redemptionCode\n  finePrint\n  isTop\n  shareableUrl\n  appUrl\n}\n\nfragment OfferList_offers on Offer {\n  id\n  ...OfferCell_offer\n}\n\nfragment OffersContainer_lists_4FAQLc on Lists {\n  offers(first: $first, after: $after, startingAfter: $startingAfter, endingBefore: $endingBefore, active: $active) {\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    edges {\n      node {\n        id\n        ...OfferList_offers\n        __typename\n      }\n      cursor\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '08ea1119205b83c74aeb06f8421cd23b';

module.exports = node;
